type BooleanFieldOf<T> = { [K in keyof T]-?: NonNullable<T[K]> extends boolean ? K : never }[keyof T];

// A boolean an association sets as its default and an assessment may override.
// See "Cascading-setting defaults resolve on `null` only" in CLAUDE.md.
export interface ICascadingSetting {
  assessmentField: BooleanFieldOf<IAssessment>;
  companyField: BooleanFieldOf<ICompany>;
  fallback: boolean;
}

export const CASCADING_SETTINGS: Record<'IS_ATTENDANCE_REQUESTED', ICascadingSetting> = {
  IS_ATTENDANCE_REQUESTED: {
    assessmentField: 'isAttendanceRequestedDefault',
    companyField: 'isAttendanceRequestedDefault',
    fallback: false,
  },
};
